import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { InputAdornment, Paper } from '@material-ui/core';
import Logo from '../../assets/logo/raz-logo.png';
import Parse from 'parse'

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { getFromAPI } from '../helpers/sqlApiCalls';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import RecoverPassword from './RecoverPassword';
import CreateUsuario from './CreateUsuario'

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Copyright() {
  return (
    <>
      <Typography variant="body2" color="textSecondary" align="center">
        FROM
      </Typography>
      <Typography style={{ fontWeight: 'bold' }} variant="body2" color="textSecondary" align="center">
        kiri
      </Typography>
    </>
  );
}

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  }
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2, 0, 5, 0)
  },
  avatar: {
    margin: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: theme.spacing(0, 6),
    textAlign: 'center'

  },
  submit: {
    margin: theme.spacing(3, 0, 0, 0),
  },
  navbar: {
    textAlign: 'center',
    marginTop: 50
  }
}));

export default function Login(props) {

  const classes = useStyles();

  const [user, setuser] = React.useState('');
  const [pass, setpass] = React.useState('');
  const [newpass, setnewpass] = React.useState('');
  const [newpassword, setnewpassword] = React.useState('');
  const [openTerms, setOpenTerms] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [navRecoverPassword, setNavRecoverPassword] = React.useState(false)
  const [navCreateUsuario, setNavCreateUsuario] = React.useState(false)

  const handleChangeUser = (event: React.ChangeEvent<HTMLInputElement>) => {
    setuser(event.target.value);
  };

  const handleChangeNewPass = (event: React.ChangeEvent<HTMLInputElement>) => {
    setnewpassword(event.target.value);
  };

  const handleChangePass = (event: React.ChangeEvent<HTMLInputElement>) => {
    setpass(event.target.value);
  };

  const [open, setOpen] = React.useState(false);

  const redirectToApp = () => {
    props.ValidateLogin(true);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleCloseTerms = (event?: React.SyntheticEvent, reason?: string) => {
    setOpenTerms(false);
  }

  const [checkbox, setState] = React.useState({
    loggedIn: false,
    terms: false
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.name === "stayLoggedIn") {
      localStorage.stayLoggedIn = event.target.checked + ""
    }
    setState({ ...checkbox, [event.target.name]: event.target.checked });
  };

  const [errmessage, seterr] = React.useState("");

  return (

    <Container component="main" maxWidth={navRecoverPassword ? "sm" : "xs"}>
      <CssBaseline />
      <div className={classes.navbar}>
        <img src={Logo} style={{ width: '50%' }} alt="Logo-Raz" />
      </div>
      <Dialog onClose={handleCloseTerms} aria-labelledby="customized-dialog-title" open={openTerms}>
        <DialogTitle id="customized-dialog-title" onClose={handleCloseTerms}>
          Terminos y condiciones
        </DialogTitle>
        {/* <DialogContent dividers>
          <Typography gutterBottom>
            • Los precios están establecidos en dólares.
          </Typography>
          <Typography gutterBottom>
            • La facturación será realizada en pesos.
          </Typography>
          <Typography gutterBottom>
            • Los pedidos serán facturados con la cotización vigente en la fecha de factura, independientemente del momento en que haya sido realizado.
          </Typography>
          <Typography gutterBottom>
            • Para que el pedido sea procesado su cuenta corriente deberá estar SIN SALDOS VENCIDOS. Las facturas vencen a los 7 días de su fecha de emisión.
          </Typography>
          <Typography gutterBottom>
            • La disponibilidad de stock mostrada al momento de realizar el pedido (semáforo) es orientativa, por lo tanto no garantiza confirmación de entrega.
          </Typography>
          <Typography gutterBottom>
            • Si al momento de facturación no hay disponibilidad del producto solicitado en el pedido, el producto queda cancelado.
          </Typography>
          <Typography gutterBottom>
            • Ante la falla de cualquier producto, el mismo deberá ser enviado a nuestros SERVICIOS TECNICOS AUTORIZADOS sin excepción, para la correspondiente revisión y validación de GARANTIA si correspondiera. NO SE ACEPTARAN DEVOLUCIONES SIN ESTA PREVIA REVISION.
          </Typography>
        </DialogContent> */}
        <DialogActions>
          <Button autoFocus onClick={handleCloseTerms} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error">
          {errmessage}
        </Alert>
      </Snackbar>

      {newpass ?
        <Paper elevation={1} className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Crea una contraseña segura
          </Typography>
          <div className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="Nueva contraseña"
              label="Password"
              type="password"
              id="password2"
              value={newpassword} onChange={handleChangeNewPass}
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={
                (x) => {
                  var byKey = new Parse.Query("RegisteredCustomers");
                  byKey.equalTo('k', user);
                  var envQuery = new Parse.Query("RegisteredCustomers");
                  envQuery.equalTo('envId', localStorage.env);
                  var byEmail = new Parse.Query("RegisteredCustomers");
                  byEmail.equalTo('e', user);
                  var mainQuery = Parse.Query.or(byKey, byEmail);
                  var passwordQuery = new Parse.Query("RegisteredCustomers");
                  passwordQuery.equalTo('p', pass);
                  var queryFinal = Parse.Query.and(envQuery, mainQuery, passwordQuery);
                  queryFinal.first().then((user) => {
                    if (user) {
                      if (newpassword !== "") {
                        user.set("p", newpassword)
                        user.set("sp", true)
                        user.save().then(() => {
                          setOpen(false);
                          redirectToApp()
                        })
                      } else {
                        setOpen(true, '');
                        seterr('La contraseña no puede quedar vacía.')
                      }
                    }
                    else {
                      //wrongData
                      setOpen(true, '');
                      seterr('Ups! Datos incorrectos, intente nuevamente.')
                    }
                  })
                }
              }
              className={classes.submit}
            >
              Guardar
            </Button>
          </div>
        </Paper>
        :
        navRecoverPassword ?
          <RecoverPassword setNavRecoverPassword={setNavRecoverPassword} />
          :
          navCreateUsuario ?
            <CreateUsuario setNavCreateUsuario={setNavCreateUsuario} redirectToApp={() => { redirectToApp() }} />
            :
            <Paper elevation={1} className={classes.paper}>
              <Avatar className={classes.avatar}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Ingresar a su cuenta
              </Typography>
              <div className={classes.form} noValidate>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Código de cliente"
                  name="email"
                  autoComplete="email"
                  value={user}
                  onChange={handleChangeUser}
                  autoFocus
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type={showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment:
                      < InputAdornment position="end" >
                        <IconButton
                          onClick={handleClickShowPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                  }}
                  id="password"
                  value={pass}
                  onChange={handleChangePass}
                  autoComplete="current-password"
                />
                <div style={{ textAlign: 'start' }}>
                  <FormControlLabel
                    control={<Checkbox checked={checkbox.stayLoggedIn} onChange={handleChange} name="stayLoggedIn" value="stayLoggedIn" color="primary" />}
                    label="Mantener sesión iniciada"
                  />
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: -11 }}>
                    <Checkbox checked={checkbox.terms} onChange={handleChange} name="terms" color="primary" />
                    <Typography>Acepto <button className='terms-btn' onClick={() => setOpenTerms(true)}>terminos y condiciones</button></Typography>
                  </div>
                </div>
                <Button
                  type="submit"
                  fullWidth
                  className={classes.submit}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    if (checkbox.terms) {

                      if (user !== "" && pass !== "") {
                        var byKey = new Parse.Query("RegisteredCustomers");
                        byKey.equalTo('k', user);
                        var envQuery = new Parse.Query("RegisteredCustomers");
                        envQuery.equalTo('envId', localStorage.env);
                        var byEmail = new Parse.Query("RegisteredCustomers");
                        byEmail.equalTo('e', user);
                        var mainQuery = Parse.Query.or(byKey, byEmail);
                        var passwordQuery = new Parse.Query("RegisteredCustomers");
                        passwordQuery.equalTo('p', pass);

                        var queryFinal = Parse.Query.and(envQuery, mainQuery, passwordQuery);
                        queryFinal.first().then(async (user) => {
                          if (user) {
                            setOpen(false);
                            localStorage.client = user.get('k')
                            localStorage.user = JSON.stringify({ ...user.attributes, id: user.id })

                            const client = await getFromAPI("Clients", `k=${localStorage.client}`)
                            const clientSellers = client[0].s
                            const seller = await getFromAPI("Sellers", `k=${Object.keys(clientSellers)[0]}`)
                            localStorage.sellerCode = Object.keys(clientSellers)[0]
                            localStorage.sellerName = seller[0].n
                            localStorage.clData = JSON.stringify({ "pl": client[0].pl, "sc": client[0].sc })
                            localStorage.clInfo = JSON.stringify(client[0])
                            if (user.get('admin')) {
                              localStorage.admin = true
                              redirectToApp()
                            } else {
                              if (user.get('sp') === true) {
                                redirectToApp()
                              } else {
                                setnewpass(true)
                              }
                              localStorage.admin = false
                            }
                          }
                          else {
                            //wrongData
                            setOpen(true, '');
                            seterr('Ups! Datos incorrectos, intente nuevamente.')
                          }
                        })

                      } else {
                        setOpen(true, '');
                        seterr('Debes completar todos los campos.')
                      }

                    }
                    else {
                      setOpen(true);
                      seterr('Debes aceptar los terminos y condiciones.')
                    }
                  }}
                >
                  Ingresar
                </Button>
                <button
                  className='text-btn'
                  style={{ paddingTop: 20, paddingBottom: 0, marginLeft: 4 }}
                  onClick={() => {
                    setNavRecoverPassword(true)
                  }}>
                  ¿Has olvidado la contraseña?
                </button>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                  <p style={{
                    padding: 0,
                    backgroundColor: "inherit",
                    color: "#a2a2a2",
                    fontSize: 16
                  }}>
                    ¿No tienes una cuenta?
                  </p>
                  <button
                    className='text-btn'
                    style={{ color: "#0f5591", padding: 0, marginLeft: 4 }}
                    onClick={() => {
                      setNavCreateUsuario(true)
                    }}
                  >
                    Regístrate
                  </button>
                </div>

              </div>
            </Paper>
      }
      <Box mt={4}>
        <Copyright />
      </Box>
    </Container >
  );
}